<template>
  <div class="product">
    <div class="title">
      <h3>{{ $t('navbar.product') }}</h3>
      <button @click="addproject">{{ $t('homepage.addproduct') }}</button>
    </div>

    <p class="tishi">{{ $t('common.sort') }}</p>

    <div class="box">
      <table>
        <thead>
          <tr>
            <th style="width: 100px">{{ $t('common.Number') }}</th>
            <th>{{ $t('product.productimg') }}</th>
            <th style="width: 350px">{{ $t('product.nameCn') }}</th>
            <th style="width: 350px">{{ $t('product.classification') }}</th>
            <th>{{ $t('product.series') }}</th>
            <th>{{ $t('common.operate') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <!-- 序号 -->
            <td><input type="text" class="inut" v-model="item.column22" @blur="inputblur(item.id, item.column22)" /></td>
            <td> 
              <img :src="`${item.exhibitsCoverImg}`" alt="" v-if="item.exhibitsCoverImg.includes('http')" />
              <img :src="`${baseUrl+item.exhibitsCoverImg}`" alt="" v-else />
            </td>
            <td>{{ item.exhibitsName }}</td>
            <!-- 产品分类 -->
            <td>{{ item.exhibitsType | productType }}</td>
            <td>{{ item.seriesName }}</td>
            <td>
              <div>
                <span @click="rowView(item.id)"><i class="el-icon-view">{{ $t('common.preview') }}</i></span>
                <span @click="rowEdit(item.id)"><i class="el-icon-edit-outline">{{ $t('common.edit') }}</i></span>

                <span @click="rowDelete(item.id)"><i class="el-icon-delete">{{ $t('common.delete') }}</i></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="item">
        <!--分页 -->
        <div class="pagination">
          <span>{{ $t('common.pagination',{ totalNum:totalNum }) }}</span>
          <el-pagination
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="5"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!--  预览页面效果  -->
    <el-card :style="{ display: viewFlag ? 'block' : 'none' }" class="viewPage">
      <Head />
      <div class="icon">
        <i class="el-icon-close" @click="closeView()"></i>
      </div>
      <div class="content" style="margin-top: 20px;">
        <div class="nav">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>展品</el-breadcrumb-item>
            <el-breadcrumb-item>展品详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="parduct_intr">
          <div class="lunbo">
            <!-- 轮播开始 -->
            <!--v-if判断一下，实现loop-->
            <swiper v-if="lunboImg.length >= 1" :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in lunboImg" :key="index">
                <img  :src="`${item.url.includes('http')?'':baseUrl}${item.url}`" alt="" v-if="item.url"/>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="introduce">
            <div class="title1">
              <h3>{{ exhibitInfo.exhibitsName }}</h3>
              <div class="border"></div>
            </div>
            <p><span>产品型号：</span>{{ exhibitInfo.column23 }}</p>
            <p><span>产品系列：</span>{{ exhibitInfo.seriesName }}</p>
            <p><span>产品类别：</span>{{ exhibitInfo.column17 }}</p>
            <div class="collent_btn">
              <button class="shoucang">咨询展商</button>
              <button class="shoucang2">收藏展商</button>
            </div>
            <div class="exhibitor">
              <div class="logo">
                <img :src="`${exhibitorInfo.comCover.includes('http')?'':baseUrl}${exhibitorInfo.comCover}`" alt="" v-if="exhibitorInfo.comCover" />
                <img src="../../../static/占位-展商-列表.png" alt="" v-else />
              </div>
              <div class="exhi_title">
                <p>{{ exhibitorInfo.companyNameC }}</p>
                <p>
                  展位号:&nbsp;&nbsp;<span style="color: #fdd000" v-for="(item, index) in exhibitorInfo.boothList" :key="index">{{ item }} &nbsp;</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="product_content">
          <h3 style="width: 152px;">展品介绍</h3>
          <div v-html="exhibitInfo.exhibitsIntro" class="content"></div>
          <!-- 视频播放 -->
          <div class="vedio"  v-if="exhibitInfo.column21">
            <video v-if="exhibitInfo.column21.substr(0,4) == 'http'" :src="`${exhibitInfo.column21}`" class="shipin" controls="controls">
              your browser does not support the video tag
            </video>
            <video v-else :src="`${baseUrl}${exhibitInfo.column21}`" class="shipin" controls="controls">
              your browser does not support the video tag
            </video>
          </div>
        </div>
        <!-- 产品参数 -->
        <div class="produce_table">
          <h3 style="width: 152px;">展品参数</h3>
          <div class="top">
            <el-row>
              <el-col :span="8">项目</el-col>
              <el-col :span="8">单位</el-col>
              <el-col :span="8">主要参数</el-col>
            </el-row>
          </div>
          <el-table v-html="exhibitInfo.techParam" class="tableDate"></el-table>
        </div>
        <!-- 产品宣传下载资料 -->
        <div class="download">
          <h3 class="hstyle">展品宣传资料</h3>
          <div class="down_box">
            <div class="down_thend">
              <p>宣传资料名称</p>
              <p>操作</p>
            </div>
            <div class="down_file down_thend" v-for="(item, index) in exhibitInfo.exhibitsAttachList" :key="index">
              <p>{{ item.name }}</p>
              <p><a v-if="item.url.substr(0,4) == 'http'" :href="item.url" download>下载</a></p>
              <p><a v-if="item.url.substr(0,4) != 'http'" :href="baseUrl + item.url" download>下载</a></p>
            </div>
          </div>
        </div>
        <div class="other_product">
          <other-product :zsId="zsId" :zpId="id" />
        </div>
      </div>
      <Foot />
    </el-card>
  </div>
</template>

<script>
import { productList, updateSort, deleteProduct, getProduct } from '../../../../api/productCenter.js';
import { forMat } from '../../../../utils/common.js';
import { getExhition } from '../../../../api/exhibitor.js';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import otherProduct from './otherProduct.vue';
import Head from '../../common/viewHead.vue';
import Foot from '../../common/foot.vue';
export default {
  data() {
    return {
      totalNum: 1,
      viewFlag: false,
      zsId: '',


      swiperOption: {
        loop: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true, 
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      lunboImg: [],





      // 展品信息
      exhibitInfo: {
        exhibitsName: '', //展品名称
        column23: '', //展品型号
        column15: '', //展品系列
        column17: '', //展品类别
        exhibitsIntro: '', //展品介绍
        exhibitsAttachList: [], //展品宣传资料
      },
      exhibitorInfo: {
        companyNameC: '', // 中文名称
        comCover: '', //公司Logo
        boothList: [], //展位号
      },
      id: '',
      exhibition: [
        { iconImg: require('../../../static/address.png'), text: '北京市东城区安外大街乙88号中煤大厦' },
        { iconImg: require('../../../static/email.png'), text: 'chinaminexpo@163.com' },
        { iconImg: require('../../../static/phone.png'), text: '010-84293556' },
        { iconImg: require('../../../static/icon_web.png'), text: '010-84293554' },
      ],
      // link: [{ text: ' 展会官网' }, { text: ' 参展申请' }, { text: ' 参观预登记' }, { text: ' 参观指南' }],
      link: [{ text: ' 我要参展' }, { text: ' 我要参观' }, { text: ' 展位图' }, { text: ' 展会日程' }, { text: ' 展会官网' }, { text: ' 煤机论坛' }],
      unit: [
        { title: '主办单位', text: '中国煤炭工业协会' },
        { title: '协办单位', text: '中国中煤能源集团有限公司' },
        { title: '承办单位', text: '中国煤炭工业国际技术咨询有限责任公司 ' },
      ],
      baseUrl: forMat(),
      tableData: [
       
      ],
      currentPage4: 1,
      pageNum: '1',
    };
  },
  components: {
    swiper,
    swiperSlide,
    otherProduct,
    Head,
    Foot,
  },
  filters:{
       productType(value){
         return String(value).replace(/[^\w^\s^\u4e00-\u9fa5]/gi, '-');
      }
  },
  methods: {
    // 获取展商信息
    async getExhibitorInfo(id) {
      const params = { id };
      try {
        const { data } = await getExhition(params);
        this.exhibitorInfo = data.data;
        var arr = [];
        data.data.hzBoothList.map((item) => {
          arr.push(item.boothNum);
        });
        this.exhibitorInfo.boothList = arr;
      } catch (err) {
        console.log(err);
      }
    },
    // 获取展品信息
    async getInitData(id) {
      this.lunboImg = [];
      const params = {
        id,
      };
      try {
        const { data } = await getProduct(params);
        if (data.code === 200) {
          this.exhibitInfo = data.data;
          if (data.data.exhibitsImg.includes(',')) {
            data.data.exhibitsImg.split(',').map((item) => {
              this.lunboImg.push({
                url: item,
              });
            });
          } else {
            const img = data.data.exhibitsImg;
            this.lunboImg = [{ url: img }];
          }

          this.getExhibitorInfo(data.data.hzExhibitorId);
          this.zsId = data.data.hzExhibitorId;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 删除
    rowDelete(id) {
      this.$confirm('确认要删除吗？', '注意!', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'myClass',
      })
        .then(() => {
          this.delItem(id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    async delItem(id) {
      const params = {
        id,
      };
      try {
        const { data } = await deleteProduct(params);
        if (data.code === 200) {
          this.getList(this.pageNum);
          this.$message({
            type: 'success',
            message: '删除产品成功!',
          });
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    // 排序函数
    async inputblur(id, sort) {
      const params = {
        id,
        sort,
      };
      try {
        const { data } = await updateSort(params);
        if (data.code === 200) {
          this.getList(this.pageNum);
          this.$message({
            type: 'success',
            message: '修改排序成功!',
          });
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    //编辑产品
    rowEdit(id) {
      this.$router.push({
        name: 'editproduct',
        query: {
          id,
        },
      });
    },
    rowView(id) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.viewFlag = true;
      this.getInitData(id);
    },
    closeView() {
      this.viewFlag = false;
    },
    addproject() {
      // this.$router.replace({name:'addproduct'})
      this.$router.push('/backIndex/addproduct');
    },
    handleCurrentChange(val) {
      this.pageNum = val;  //更新页码的数值
      console.log("页面加载变化",this.pageNum);
      this.getList(this.pageNum);
    },
    //提示框
    open(index) {
      this.$confirm('确认要删除吗？', '!注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'myClass',
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    async getList(pageNum) {
      const params = {
        page: pageNum,
        size: '5',
      };

      try {
        const { data } = await productList(params);
        this.totalNum = data.data.count
        this.tableData = data.data.list;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getList('1');
  },
};
</script>
<style lang="scss" scoped>
.product {
  box-sizing: border-box;
  padding: 18px 26px 0 26px;
  background: white;
  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    h3 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    button {
      width: 77px;
      height: 32px;
      background: #006fb8;
      color: white;
      border-radius: 2px;
      border: none;
    }
  }

  .tishi {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff190c;
    line-height: 18px;
  }
  table {
    margin: 15px 0px 0px 0px;
    border-collapse: collapse;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    border-radius: 3px 3px 0px 0px;
    width: 100%;
    overflow: hidden;
    thead {
      //width: 100%;
      background: #006fb8;
      border-radius: 4px 4px 0px 0px;
      tr {
        height: 36px;
        color: rgba(255, 255, 255, 0.85);
        width: 100%;
        th {
          box-sizing: border-box;
          height: 36px;
          width: 200px;
          color: white;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }
    tbody {
      tr {
        height: 106px;
        border-bottom: 1px solid #e8e8e8;
        td {
          text-align: center;
          height: 106px;
          img {
            width: 104px;
            height: 78px;
            margin: 10px 0px;
          }
          span {
            color: #006fb8;
            margin: 0px 5px;
            cursor: pointer;
          }
          .inut {
            display: block;
            width: 35px;
            height: 24px;
            border: 1px solid #e0e0e0;
            line-height: 24px;
            color: #666666;
            margin-left: 25px;
            text-align: center;
          }
        }
        &:nth-child(even) {
          background-color: #f6f6f7;
        }
      }
    }

    .leaseCount {
      width: 100px;
      div {
        margin: 0 auto;
        text-align: center;
        width: 92px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.box {
  //   border: 1px solid rgb(92, 0, 221);
  height: 750px;
  position: relative;
  .item {
    // height: 40px;
    // background-color: skyblue;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .pagination {
    // border: 1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 26px;
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-top: 6px;
      color: #666666;
    }
  }
}
</style>
<style lang="scss" scoped>
.viewPage {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  .icon {
    top: 120px;
    position: absolute;
    right: 35px;
    font-size: 25px;
    color: #333;
  }
  h3 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 28px;
    color: #006fb8;
    border-left: 3px solid #006fb8;
    border-right: 3px solid #006fb8;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  .content {
    width: 100%;
    box-sizing: border-box;
    // padding-left: 275px;
    // padding-right: 275px;
    .parduct_intr {
      display: flex;
      margin-top: 42px;
      .lunbo {
        width: 692px;
        height: 520px;
        // border: 1px solid red;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        img {
          max-width:100%;
           height:auto; 
           max-height: 100%;
          // margin-top: 48px;
        }
        .swiper-container {
          position: relative;
          width: 100%;
          height: 100%;
        }
        .swiper-container .swiper-slide {
          width: 100%;
          line-height: 200px;
          //   background: yellowgreen;
          color: #000;
          font-size: 16px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .swiper-button-prev {
          background-image: url('../../../static/ico-leftprev.png');
        }
        .swiper-button-next {
          background-image: url('../../../static/ico-rightNex.png');
        }
      }
      .introduce {
        width: 490px;
        height: 520px;
        margin-left: 86px;
        // border: 1px solid red;
        box-sizing: border-box;
        padding: 24px 0 0 0;
        .title1 {
          // width: 431px;
          h3 {
            height: 31px;
            font-size: 30px;
            line-height: 31px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            border: none;
          }
          .border {
            width: 100%;
            height: 3px;
            background: #006fb8;
          }
        }

        p {
          margin-top: 20px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;

          color: #333333;
        }
        .collent_btn {
          .shoucang {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            background: #006fb8;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            margin: 18px 11px 0 0;
          }
          .shoucang:hover {
            background: #338cc6;
            cursor: pointer;
          }
          // .shoucang:active {
          //   background: #0064a6;
          // }
          .shoucang2 {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            background: #fdd000;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            //   margin: 22px 0 0 50px;
          }

          .shoucang2:hover {
            border: 1px solid transparent;
            background: #fdd933;
            cursor: pointer;
          }

          .shoucang3 {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            background: #ededed;
            border-radius: 4px;
          }
          .shoucang3:hover {
            border: 1px solid transparent;
            background: #ededed;
            cursor: pointer;
          }
        }
        .exhibitor {
          width: 489px;
          height: 136px;
          display: flex;
          margin-top: 104px;
          border: 1px solid #e0e0e0;
          .logo {
            width: 237px;
            height: 136px;
            box-sizing: border-box;
            border: 1px solid #e0e0e0;
            display: flex;
            align-items: center;
            img {
              width: 100%;
              height: auto;
            }
          }
          .exhi_title {
            box-sizing: border-box;
            padding-left: 20px;
            p {
              margin-top: 20px;
            }
          }
        }
      }
    }
    .product_content {
      margin-top: 100px;
      .content {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 27px;
        margin-top: 27px;
        text-indent: 2em;
      }
      .vedio {
        width: 800px;
        height: 450px;
        margin: 0 auto;
        margin-top: 42px;
        // border: 1px solid red;
      }
      .shipin {
        width: 100%;
        height: 450px;
      }
      p {
        text-indent: 2em;
      }
    }
    .produce_table {
      margin-top: 100px;
      .top {
        height: 40px;
        background: #006fb8;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        .el-row {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .grid-content {
          border-radius: 4px;
          min-height: 36px;
        }
        .row-bg {
          padding: 10px 0;
          background-color: #f9fafc;
        }
      }
    }
    //产品宣传下载资料
    .download {
      margin-top: 100px;
      .hstyle {
        width: 214px;
      }
      .down_box {
        .down_thend {
          display: flex;
          height: 40px;
          color: white;
          background-color: #fdd000;
          align-items: center;
          padding: 0px 30px;
          justify-content: space-between;
          p :first-child {
            width: 800px;
          }
        }
        .down_file {
          background-color: white;
          color: #333;
          border-bottom: 1px solid #e0e0e0;
          height: 51px;
        }
        a {
          text-decoration: none;
          color: #006fb8;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
<style lang="scss">
.myClass {
  border: none;
  .el-message-box__header {
    background: #006fb8;
    color: white !important;
  }
  .el-button--primary {
    background: #006fb8;
  }
}
.el-message-box__title {
  color: white !important;
}
</style>
<style scoped>
.el-table >>> td {
  border-bottom: 1px solid #ebeef5;
  border-right: 0px;
  border-left: 0px;
  text-align: center;
}
.el-table >>> table {
  border: 0px;
}
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(3n-1) {
  background: #e0e0e0;
}
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(2n + 1) {
  background: #e0e0e0;
}
.tableDate >>> td:nth-child(1) {
  display: table-cell;
  text-align: center;
  align-items: center;
}
</style>
